module.exports = __webpack_public_path__ + "static/img/brees-2016-slide-2.e5e1d1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2016-slide-2.jpg
// module id = /duA
// module chunks = 1